<template>
  <div>
    <Loading
      v-if="disabledPayButton"
      text="Loading ..."
      style="margin-left: 0px;"
    />

    <table v-else-if="shoppingBagProducts.length || localCart.length">
      <thead>
        <tr>
          <th class="product-header">Product</th>
          <th class="product-title">Product Title</th>
          <th class="product-size">Option</th>
          <th class="product-quantity">Quantity</th>
          <th class="product-subtotal" v-show="showPrices">Subtotal</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(product, index) in isConfirmedOrder
            ? localCart
            : shoppingBagProducts"
          :key="index"
        >
          <!-- Product Image Here -->
          <td>
            <div class="flex justify-center">
              <img
                :src="photoURL(product)"
                @click="editItem(product)"
                @error="handleBrokenImage($event)"
              />
            </div>
          </td>

          <!-- Product title here -->
          <td>
            <!-- Product display here -->
            <div class="display-name">
              <span @click="editItem(product)">
                {{ displayName(product) }}</span
              >
              <img
                src="@/assets/dropdownarrow.svg"
                v-if="product.type == 'bundle'"
                class="arrow"
                :class="{ active: index + 1 === activeBundle }"
                @click="revealBundleItems(index)"
              />
            </div>

            <div
              v-if="product.type == 'bundle' && index + 1 === activeBundle"
              class="selected-variants first"
              :class="{ active: index + 1 === activeBundle }"
            >
              <p v-for="(item, i) in product.items" :key="i">
                {{ item.name || '' }}
              </p>
            </div>
          </td>

          <!-- Product Option Here -->
          <td>
            <span class="enter-line h-35">{{
              displaySelection(product.selectedVariant)
            }}</span>

            <div
              v-if="product.type == 'bundle' && index + 1 === activeBundle"
              class="selected-variants second"
              :class="{ active: index + 1 === activeBundle }"
            >
              <p v-for="(item, i) in product.items" :key="i" class="centered">
                <span
                  :class="{
                    'selected-variants-none': displaySelection(item) === 'none'
                  }"
                >
                  {{ displaySelection(item) }}
                </span>
              </p>
            </div>
          </td>

          <!--  Product Quantity here -->
          <td>
            <div class="h-35 ">
              <ul>
                <li :class="{ hidden: disableActions }">
                  <span @click="decreaseItem({ ...product, index })">-</span>
                </li>
                <li>{{ product.quantity }}</li>
                <li :class="{ hidden: disableActions }">
                  <span @click="increaseItem({ ...product, index })">+</span>
                </li>
              </ul>
            </div>

            <div
              v-if="product.type == 'bundle' && index + 1 === activeBundle"
              class="selected-variants quantity"
            >
              <p v-for="(item, i) in product.items" :key="i" class="right">
                {{ item.quantity * product.quantity }}
              </p>
            </div>
          </td>

          <!-- Product price here -->
          <td v-show="showPrices">
            <div class="h-35">
              {{
                formatCurrency(
                  product.type == 'bundle'
                    ? product.bundle_attributes.lowestPrice * product.quantity
                    : product.selectedVariant.price * product.quantity
                )
              }}
            </div>

            <div
              v-if="product.type == 'bundle' && index + 1 === activeBundle"
              class="selected-variants hidden "
              :class="{ active: index + 1 === activeBundle }"
            >
              <p v-for="(item, i) in product.items.length" :key="i">
                {{ product.quantity }}
              </p>
            </div>
          </td>

          <!-- Delete Item here -->
          <td>
            <span
              class="remove"
              :class="{ hidden: disableActions }"
              @click="removeItem(product)"
              >x</span
            >

            <div
              v-if="product.type == 'bundle' && index + 1 === activeBundle"
              class="selected-variants hidden"
              :class="{ active: index + 1 === activeBundle }"
            >
              <p v-for="(item, i) in product.items.length" :key="i">
                {{ product.quantity }}
              </p>
            </div>
          </td>
        </tr>
      </tbody>
      <!-- Footer Region Here -->
      <slot />
    </table>

    <div v-else>
      <EmptyShoppingBag />
    </div>
  </div>
</template>

<script>
import { defaultNotFoundImage, isCard, handleBrokenImage } from '@/helpers'
import Util from '../../mixins/Util'
import { mapState } from 'vuex'
import EmptyShoppingBag from '@/components/SendGiftFlow/EmptyShoppingBag'
import Loading from '@/components/Loading'

export default {
  name: 'ShoppingCart',
  mixins: [Util],

  props: {
    disableActions: {
      type: Boolean,
      default: false
    }
  },

  components: { EmptyShoppingBag, Loading },

  data: () => ({
    activeBundle: '',
    localCart: [],
    handleBrokenImage: handleBrokenImage
  }),

  computed: {
    ...mapState({
      shoppingBagProducts: state => state.order.shoppingBagProducts,
      disabledPayButton: state => state.order.disabledPayButton
    }),
    showPrices() {
      return this.$store.getters['team/showPrices']
    },
    isConfirmedOrder() {
      return this.$route.name === 'ConfirmedOrder'
    }
  },

  created() {
    this.loadLocalCart()
  },

  methods: {
    loadLocalCart() {
      const data = localStorage.getItem('localCart')
      const parsedData = JSON.parse(data)
      if (data && this.isConfirmedOrder) {
        this.localCart = parsedData.cart
      }
    },
    revealBundleItems(id) {
      this.activeBundle = this.activeBundle == id + 1 ? '' : id + 1
    },
    photoURL(product) {
      if (product.type == 'bundle') {
        return product.bundle_attributes &&
          product.bundle_attributes.images &&
          !!product.bundle_attributes.images.length
          ? product.bundle_attributes.images[0].url
          : defaultNotFoundImage
      }

      return product.selectedVariant && product.selectedVariant.imageURL
        ? product.selectedVariant.imageURL
        : defaultNotFoundImage
    },
    displayName(product) {
      if (product.type == 'bundle') {
        return product.bundle_attributes && product.bundle_attributes.name
      }
      return product.selectedVariant && product.selectedVariant.displayName
    },
    removeItem(product) {
      if (product.attributes && isCard(product.attributes.tagList)) {
        localStorage.removeItem('selectedCard')
      }
      this.$store.dispatch('order/removeShoppingBagItem', product)
    },
    increaseItem(product) {
      if (product.type == 'bundle') {
        return this.$store.dispatch('order/increaseBundleItem', product)
      }

      this.$store.dispatch('order/increaseShoppingBagItem', product)
    },

    decreaseItem(product) {
      this.$store.dispatch('order/decreaseShoppingBagItem', product)
    },
    editItem(product) {
      if (product.type) {
        return this.productDetail(product)
      }
    },
    productDetail(product) {
      const route = product.type == 'bundle' ? 'BundleDetail' : 'ProductDetail'
      const id = product.type == 'bundle' ? product.bundle_id : product.id
      const queryData = JSON.stringify(
        product.type == 'bundle'
          ? product.bundle_attributes
          : product.selectedVariant
      )

      this.$router.push({
        name: route,
        params: {
          id: id
        },
        query: {
          productVariant: queryData,
          quantity: product.quantity
        }
      })
    },
    displaySelection(variant) {
      if (variant) {
        let selections = []
        if (variant.type) selections.push(variant.type)
        if (variant.color) selections.push(variant.color)
        if (variant.size) selections.push(variant.size)
        if (selections.length === 0) {
          return 'none'
        }
        return selections.map(selection => selection).join('\n')
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.selected-variants-none {
  visibility: hidden;
}
table {
  width: 100%;
  margin-top: 2rem;
  border-spacing: 0px;
  border-collapse: separate;
  font-family: $inter;

  & thead > tr > th {
    padding: 1rem;
    border-bottom: 1px solid $onyx;
    font-size: 0.813rem;

    &:nth-child(n + 3) {
      padding: 1rem 0rem;
    }
    &:nth-child(4) {
      padding-left: 1rem;
    }
    &:nth-child(5) {
      padding-right: 2rem;
    }
  }

  & tbody > tr > td {
    padding: 0.5rem 0rem;
    font-size: 0.813rem;
    border-bottom: 1px solid $onyx;
  }

  & tbody > tr > td:nth-child(2) {
    text-align: left;
  }
  & tbody > tr > td:nth-child(5) {
    padding-right: 2rem;
  }

  & tbody > tr > td:nth-child(4) {
    padding-left: 1rem;
  }
  & tbody > tr > td:nth-child(6) {
    padding-right: 1.5rem;
  }

  & tfoot > tr > td {
    font-size: 0.813rem;
    padding-top: 2rem;
  }

  & tfoot > tr > td:nth-child(4) {
    font-weight: 700;
    padding-left: 2rem;
  }

  .product-header {
    width: 20%;
  }

  .product-title {
    width: 40%;
    text-align: left;
  }
}

img {
  width: 98px;
  height: 98px;
  max-width: 100%;
  object-fit: contain;
  cursor: pointer;
}

ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

ul li {
  font-size: 0.813rem;
  padding-right: 0.5rem;
  line-height: 30px;
}

ul li span {
  cursor: pointer;
  display: block;
  width: 30px;
  user-select: none;
}

.remove {
  cursor: pointer;
  display: block;
  width: 20px;
  user-select: none;
  font-size: 13px;
  color: $main-6;
}

.display-name {
  display: flex;
  align-items: center;
  height: 3.5rem;
  padding: 0rem 0.875rem;

  span {
    cursor: pointer;
  }

  img {
    margin-left: 10px;
    width: 9px;
    cursor: pointer;
    transition: transform 0.8s ease;
  }
}

.arrow.active {
  transform: rotateX(180deg);
}

.selected-variants {
  background: inherit;
  padding: 0.875rem;
  padding-bottom: 0;

  -webkit-transition: 0.5s ease;
  -moz-transition: 0.5s ease;
  transition: 0.5s ease;
  overflow: hidden;

  &.first {
    border: 1px solid $onyx;
    border-right: none;
  }

  &.second {
    border: 1px solid $onyx;
    border-left: none;
    border-right: none;
  }

  &.active {
    transition: 1.5s ease-in-out;
  }

  &.quantity {
    border: 1px solid $onyx;
    border-left: none;
    width: 75%;

    .right {
      text-align: right;
      width: inherit;
    }
  }

  &.hidden {
    visibility: hidden;
  }

  p {
    padding-bottom: 0.75rem;
    font-size: 0.688rem;
    text-align: left;

    &.centered {
      text-align: center;
    }
  }
}

.h-35 {
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hidden {
  visibility: hidden;
}
</style>
